import { deleteGroupDeepLink } from 'APP/model/group/groupModel';
import Entities from 'STORE';

type IUpdateDeepLinkBody = {
  groupId: string;
};

export async function updateDeepLink(data: IUpdateDeepLinkBody): Promise<boolean> {
  try {
    const personalizedGroup = await deleteGroupDeepLink(data);

    if (!personalizedGroup) {
      return true;
    }

    Entities.GroupsStore.merge([personalizedGroup]);
    return true;
  } catch {
    return false;
  }
}
